import {Component, input, model, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {DropdownModule} from 'primeng/dropdown';
import {SelectButtonModule} from 'primeng/selectbutton';

import {Helpers} from '@selpia/shared/utils';

@Component({
  selector: 'lib-select-button',
  imports: [CommonModule, SelectButtonModule, FormsModule, DropdownModule],
  templateUrl: './select-button.component.html',
  styleUrl: './select-button.component.scss',
})
export class SelectButtonComponent<T, K extends keyof T & string> {
  readonly options = input.required<T[]>();
  readonly model = model<T>();
  readonly label = input<string | undefined>();
  readonly labelKey = input<K>();
  readonly testTriggerKey = input<K>();

  protected readonly innerId = signal(Helpers.generateRandomString())
    .asReadonly();
}
